<template>
  <div
    v-if="loaded"
    class="page laboratory-tracking-view"
  >
    <div class="sidebar__tracking">
      <sidebar-tracking
        v-if="$route.name === 'ContentTracking'"
        ref="sideBarTracking"
        @tabToggle="tabToggle"
      />
    </div>
    <div class="page__main">
      <router-view
        :show-message-alt="showMessageAlt"
        :section-title="sentTitle"
      />
    </div>
  </div>
</template>

<script>
import SidebarTracking from '@/modules/laboratoryModule/laboratoryTracking/sidebarTracking/SidebarTracking'
import { assayState } from '@/api/resources/entityState/assay-state'

export default {
    name: 'LaboratoryTrackingView',
    components: {
        SidebarTracking
    },
    data() {
        return {
            sentTitle: null,
            showMessageAlt: false,
            loaded: false
        }
    },
    async created() {
        const [err] = await this.toCall(assayState.loadStates())
        if (err) {
            this.showErrorModalGlobal()
            return
        }
        this.loaded = true
    },
    methods: {
        tabToggle(value) {
            this.showMessageAlt = value
        }
    }
}

</script>

<style scoped>

.laboratory-tracking-view {
    height: calc(100vh - 50px);
}

.laboratory-tracking-view .page__main{
  overflow-y: auto;
  padding: 0;
}

</style>

<style>

#app .laboratory-tracking-view .navbar{
  display: none !important;
}

</style>
